<template>
    <div class="page-wrapper">
        <div class="container">
            <div class="login-form">
                <div class="logo"><img src="../image/logo.png"></div>
                <form>
                    <div class="fieldset">
                        <label class="fieldset-title">Телефон</label>
                        <fieldset><input type="text" v-model="username" @keyup="enterKeyListener"></fieldset>
                    </div>
                    <div class="fieldset">
                        <label class="fieldset-title">Пароль</label>
                        <fieldset><input type="password" v-model="password" @keyup="enterKeyListener"></fieldset>
                    </div>
                    <div class="buttons">
                        <button type="button" @click="login">Войти</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login () {
      const { username, password } = this
      this.$store
        .dispatch('auth', { username, password })
        .then(() => {
          let page = sessionStorage.getItem('shustrikoff_redirect')
          if (!page) {
            page = '/orders'
          }
          sessionStorage.removeItem('shustrikoff_redirect')
          this.$router.push(page)
        })
        .catch(message => alert(message))
    },
    enterKeyListener (e) {
      if (e.keyCode == 13) {
        this.login()
      }
    }
  },
  mounted () {
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');
  },
  destroyed () {
    let body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page')
  }
}
</script>
